import React from 'react'
import Logo from '../assets/footer_logo.png'
import { Link } from 'react-router-dom'
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const Footer = () => {
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    };
    return (
        <div className='bg-bgprimary pt-[70px]  min-h-[200px]' >
            <div className="max-w-[1350px] grid md:grid-cols-3 grid-cols-1 gap-5 px-4 mx-auto">
                <div className="">
                    <img src={Logo} alt="" />
                    <p className='text-dark font-quicksand font-medium text-[16px] my-5 max-w-[400px]' >
                        Every destination shaped our vision,
                        each journey inspired us to reimagine
                        travel gear. Now we're transforming
                        the way adventurers explore the world!
                    </p>

                </div>
                <div className="self-end md:col-span-2 col-span-1 md:text-right">
                    {/* <div className="my-4 flex gap-4 items-center justify-end ">
                        <Link to="/"  >
                            <FaFacebookF size={18} color='#52525B' />
                        </Link>
                        <Link to="/" >
                            <FaTwitter size={18} color='#52525B' />
                        </Link>
                        <Link to="/" >
                            <FaLinkedinIn size={18} color='#52525B' />
                        </Link>
                        <Link to="/" >
                            <FaInstagram size={18} color='#52525B' />
                        </Link>
                    </div> */}

                    <ul className='flex items-center flex-wrap md:justify-end md:gap-4 gap-3' >
                        <li className=' inline-block'>
                            <Link to={`/about`} className='text-dark font-quicksand font-bold text-[1rem] text-xs ' onClick={handleScrollToTop} > About Us </Link>
                        </li>
                        <li className=' inline-block'>
                            <Link
                                to="mailto:support@westbreezetravel.com"
                                target='_blank'
                                className="text-dark font-quicksand font-bold text-[1rem] text-xs"
                            >
                                Contact Us
                            </Link>
                        </li>
                        <li className=' inline-block'>
                            <Link to={`/packing-list`} className='text-dark font-quicksand font-bold text-[1rem] text-xs ' onClick={handleScrollToTop} > Packing List </Link>
                        </li>
                        <li className=' inline-block'>
                            <Link to={`https://www.kickstarter.com/projects/westbreezetravel/packing-cubes-hanging-wardrobe-instantly`} target='_blank' className='text-dark font-quicksand font-bold text-[1rem] text-xs ' onClick={handleScrollToTop} > Products </Link>
                        </li>
                        <li className=' inline-block'>
                            <Link to={`/terms-and-condition`} className='text-dark font-quicksand font-bold text-[1rem] text-xs ' onClick={handleScrollToTop} > Terms & Conditions </Link>
                        </li>
                        <li className=' inline-block'>
                            <Link to={`/privacy-policy`} className='text-dark font-quicksand font-bold text-[1rem] text-xs ' onClick={handleScrollToTop} > Privacy Policy </Link>
                        </li>
                    </ul>
                </div>
                {/* <div className="">
                    <h2 className='text-dark font-roboto-mono font-bold text-[18px]' >Contact</h2>
                    <ul className='mt-5' >
                        <li className='my-5 flex items-center gap-3'>
                            <span>
                                <FaPhoneAlt size={18} />
                            </span>
                            <span className='text-dark font-quicksand font-medium text-[16px] ' > (406) 555-0120 </span>
                        </li>
                        <li className='my-5 flex items-center gap-3'>
                            <span>
                                <FaEnvelope size={18} />
                            </span>
                            <span className='text-dark font-quicksand font-medium text-[16px] ' > mangcoding123@gmail.com </span>
                        </li>
                        <li className='my-5 flex items-center gap-3'>
                            <span>
                                <FaMapMarkerAlt size={18} />
                            </span>
                            <span className='text-dark font-quicksand font-medium text-[16px] ' > 2972 Westheimer Rd. Santa Ana, Illinois 85486  </span>
                        </li>

                    </ul>
                </div> */}


            </div>
            <div className="text-center mt-6  pb-4 pt-2 max-w-[1350px] mx-auto px-4">
                <div className="flex flex-col md:flex-row items-center justify-center gap-1 md:gap-2">
                    <span className="text-sm text-dark font-quicksand">
                        &copy; {new Date().getFullYear()} West Breeze Travel. All rights reserved.
                    </span>
                    <span className="hidden md:inline text-dark">|</span>
                    <span className="text-xs text-dark font-quicksand">
                        Designed &amp; Developed by <a href="https://senewtech.com" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-700">Senew Tech</a>
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Footer
